import { render, staticRenderFns } from "./MuseumCard.vue?vue&type=template&id=ed6567f2&scoped=true&"
import script from "./MuseumCard.vue?vue&type=script&lang=js&"
export * from "./MuseumCard.vue?vue&type=script&lang=js&"
import style0 from "./MuseumCard.vue?vue&type=style&index=0&id=ed6567f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6567f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VDivider,VIcon,VImg})
